import axiosInstance from "./axiosConfig";
import { AddBlockedKeywords, BlockedKeywords } from '../types/blocked-keywords';

export const getBlockedKeywords = async () => {
    const response = await axiosInstance.get<BlockedKeywords[]>('/blocked-keywords');
    return response?.data;
};

export const createBlockedKeywords = async (blockedKeywords: AddBlockedKeywords) => {
    const response = await axiosInstance.post<BlockedKeywords>('/blocked-keywords', blockedKeywords);
    return response?.data;
}

export const updateBlockedKeywords = async (blockedKeywords: BlockedKeywords) => {
    const response = await axiosInstance.patch<BlockedKeywords>(`/blocked-keywords/${blockedKeywords.id}`, blockedKeywords);
    return response?.data;
}
